import React from "react";
import { Link } from "react-router-dom";
import PolicyLayout, { Section } from "@/components/PolicyLayout";
import { COMPANY } from "@/constants/company";

export default function Terms() {
    return (
        <PolicyLayout
            eyebrow="Legal" title="Terms of service" testId="terms-page"
            intro={`These terms cover your use of ${COMPANY.name}. By creating an account or placing an order you agree to them.`}>

            <Section heading="What we make">
                <p>
                    You give us a child's photo, the people who should appear alongside them, and a
                    world to set the story in. Our illustrators produce a personalised storybook from
                    that, delivered as a print-ready PDF and — if you ordered one — a printed hardcover.
                </p>
                <p>
                    Every book is drawn to order for one family. Page counts, art style and story
                    length follow what you chose in the wizard; small creative differences between
                    your brief and the finished book are part of illustration, not a defect.
                </p>
            </Section>

            <Section heading="Photos and consent">
                <p>
                    You may only upload photos of a child you are the parent or legal guardian of, or
                    of adults who have agreed to appear. By uploading, you confirm you have that right.
                </p>
                <p>
                    We use the photos solely to draw your book. We do not sell them, publish them, or
                    use them to advertise without asking you first, and you can delete them from your
                    library at any time.
                </p>
            </Section>

            <Section heading="Ordering and payment">
                <p>
                    Prices shown at checkout are in Indian rupees and include applicable taxes. Payment
                    is taken through Razorpay or by direct UPI transfer. Work begins once payment is
                    confirmed — for UPI that is when we have matched the credit in our account, which
                    can take up to 24 hours.
                </p>
                <p>
                    Refunds are covered separately in our{" "}
                    <Link to="/refund-policy" className="underline hover:text-plum">payments and refunds policy</Link>.
                </p>
            </Section>

            <Section heading="Delivery">
                <p>
                    Digital books normally land in your library within 48 hours of confirmed payment.
                    Hardcovers are printed and posted after that; we email tracking when they ship.
                    These are targets, not guarantees — if something will be materially late, we tell you.
                </p>
            </Section>

            <Section heading="Who owns what">
                <p>
                    The finished book is yours. Print it, gift it, read it aloud, keep it forever.
                </p>
                <p>
                    What you may not do is resell the artwork, use it commercially, or pass the PDF
                    off as stock illustration. Shared reading links are for people you choose to send
                    them to; you can revoke a link at any time.
                </p>
            </Section>

            <Section heading="Your account">
                <p>
                    Keep your password to yourself — anything done from your account is treated as done
                    by you. Tell us straight away if you think someone else has access.
                </p>
                <p>
                    We may suspend an account that uploads content involving someone who has not
                    consented, or that is used to abuse the service.
                </p>
            </Section>

            <Section heading="Limits">
                <p>
                    We do our best to keep the service up, but we do not promise it is uninterrupted or
                    error-free. Where the law allows us to limit our liability, it is limited to what
                    you paid for the order in question.
                </p>
                <p>
                    Nothing here removes rights you have under Indian consumer law.
                </p>
            </Section>

            <Section heading="Changes and contact">
                <p>
                    If we change these terms we update the date at the bottom of this page. Orders are
                    governed by the terms in force when you placed them. These terms are governed by
                    the laws of India.
                </p>
                <p>
                    Questions go to <a href={`mailto:${COMPANY.email}`} className="underline hover:text-plum">{COMPANY.email}</a>{" "}
                    or the <Link to="/contact" className="underline hover:text-plum">contact page</Link>.
                </p>
            </Section>
        </PolicyLayout>
    );
}
